import {  ID_PREFIX_FRAMES } from './FrameSvgConstants'
import FrameTypes from '../assets/frametraits/frame_types_ids.json'
export const frameStyleForTrait = (frameStyle = 0) => {
  return ID_PREFIX_FRAMES.concat(frameStyle % Object.keys(FrameTypes).length)
}
